import { Flex } from 'ui';
import type { PostType } from '../ProgramTopicPost';
import { HeaderImage } from './header-image';

type P = {
  last: boolean;
  postType: PostType;
  type?: 'checked' | 'selected' | 'unchecked';
};

const ProgramTopicPostHeader = ({ last, postType, type }: P) => (
  <Flex align="center" className="program-topic-post-header" justify="center" vertical>
    <HeaderImage postType={postType} type={type} />
    {last ? undefined : <div className="program-topic-post-header__line" />}
  </Flex>
);

export default ProgramTopicPostHeader;
